<div class="participant-info">
    <ms-horse-info-header [participant]="participant" [participantInfo]="participant.timeformInfo"></ms-horse-info-header>
    <ms-horse-info-description [participantInfo]="participant.timeformInfo" [performanceData]="participantPerformances"></ms-horse-info-description>
    <div class="participant-last-results" *ngIf="participantPerformances.length">
        <table>
            <thead>
                <tr>
                    <th>{{ sitecore.horseRacing.raceDetails.ResultDate }}</th>
                    <th>{{ sitecore.horseRacing.raceDetails.ResultCourse }}</th>
                    <th>{{ sitecore.horseRacing.raceDetails.ResultDist }}</th>
                    <th>{{ sitecore.horseRacing.raceDetails.ResultG }}</th>
                    <th>{{ sitecore.horseRacing.raceDetails.ResultPos }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let result of participantPerformances">
                    <td>{{ result.meetingDate | date: 'MMM d, y' }}</td>
                    <td>
                        <div class="course-name">{{ result.courseName || '-' }}</div>
                    </td>
                    <td>{{ result.raceDistanceText.toLowerCase() || '-' }}</td>
                    <td>{{ result.raceGoingAbbrev || '-' }}</td>
                    <td>{{ result.positionOfficial || '-' }}/{{ result.raceNumberOfRunners || '-' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
